<template>
  <svg class="svg-icon" v-on="$listeners" :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        // console.log(this.className)
        return this.className
        // return `${this.className}h`
      } else {
        return 'base-wh'
      }
    }
  }
}
</script>

<style scoped>
.base-wh {
  width: 1em;
  height: 1em;
}
.svg-icon {
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
